import { Typography } from '@mui/material';

const NoRecords = (): JSX.Element => {
  return <Typography>No records found</Typography>;
};

export default NoRecords;
